import type { RouteRecordRaw } from 'vue-router';

const CampaignDetailsPage = () => import('@/views/details/CampaignDetailsPage.vue');
const CreateCampaignPage = () => import('@/views/create/create-campaign-v2/CreateCampaignPage.vue');
const PublicCampaignDetails = () => import('@/views/public/campaign-details/CampaignDetails.vue');

export const campaignRoutes: RouteRecordRaw[] = [
  {
    path: '/companies/:company_id/details/:campaign_id',
    name: 'campaign-details',
    meta: { requireOwnership: true },
    component: CampaignDetailsPage,
  },
  {
    path: '/companies/:company_id/create',
    name: 'create-campaign',
    meta: { requireOwnership: true },
    component: CreateCampaignPage,
  },
  {
    path: '/public/campaign-details/:campaign_id',
    name: 'public-campaign-details',
    component: PublicCampaignDetails,
    meta: { requireAnonymous: false },
  },
];
